module.exports = __webpack_public_path__ + "img/cable-tv.387f088f.svg";